module.exports = __webpack_public_path__ + "static/step2-2ff2d9118dc9f98d6cb0ea6d10b3ba69.png";